import React from 'react';
import './Header.css';
import {Col} from 'react-bootstrap';

const Header = ({setLanguage}) => {
    const handleChange = (event) => {
        const selectedLanguage = event.target.value;
        setLanguage(selectedLanguage);
    };

    return (
        <div className="header">
            <div className="escudoContainer">
            <Col sm={9}>
                <img src="/img/logo-rb.png" alt="Logo" className="escudoHeader"/>
            </Col>
            <Col sm={3} >
                <select onChange={handleChange} className="languageSelect">
                    <option value="es" className="optionSelect">ES</option>
                    <option value="en">EN</option>
                </select>
            </Col>
            </div>
        </div>
    );
};

export {Header};